import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import { useCustomersByUuid } from '../../hooks/use-customers';
import { Customers as CustomersCommon } from '../common/customers';

import styles from './customers.module.scss';

export const Customers = ({ data }) => {
	const items = useCustomersByUuid(data.items);

	return (
		<div className={styles.wrapper}>
			<CustomersCommon
				items={items}
				header={<h2>{data.header}</h2>}
				footer={
					<Link to={data.link.url} className={styles.button}>
						{data.link.label}
					</Link>
				}
			/>
		</div>
	);
};

Customers.defaultProps = {
	data: {},
};

Customers.propTypes = {
	data: PropTypes.object.isRequired,
};
